import React from 'react';
import IconNamesType, {iconMap} from './IconNamesType';

interface IconProps extends React.SVGProps<SVGSVGElement> {
	name: IconNamesType;
	size?: number | string;
	color?: string;
	className?: string;
	style?: React.CSSProperties;
	onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({
	name,
	size = '24px',
	color = 'currentColor',
	className,
	onClick,
	style,
	...props
}) => {
	const SvgIcon = iconMap[name];

	if (!SvgIcon) {
		return null;
	}

	return (
		<SvgIcon
			width={size}
			height={size}
			fill={color}
			className={className}
			style={{
				cursor: onClick ? 'pointer' : 'inherit',
				...style,
			}}
			onClick={onClick}
			aria-hidden="true"
			focusable="false"
			{...props}
		/>
	);
};

export default Icon;
